import { reqAPI } from "../utils/fetch-request";

export async function getBalance(){
  return reqAPI('api/merchant/balance');
}

export async function historyBalance(params = {}){
  return reqAPI('api/merchant/history-balances', params);
}

export async function exportBalanceHistory(params = {}) {
  return reqAPI('api/merchant/history-balances/export', params, 'GET', false, 'blob');
}

export async function getListVA(){
  return reqAPI('api/merchant/list-va');
}